import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { CONTACT } from "@/data/site";
import { Phone } from "lucide-react";

export const MarketingLayout = () => (
  <div className="grain-overlay min-h-screen flex flex-col bg-brand-light">
    <Navbar />
    <main className="flex-1 relative z-10">
      <Outlet />
    </main>
    <Footer />
    <ChatWidget />
    <a
      data-testid="emergency-call-btn"
      href={`tel:${CONTACT.phoneRaw}`}
      className="fixed bottom-6 left-6 z-[60] pulse-ring flex items-center gap-2 bg-[#E53E3E] text-white font-bold px-5 py-3 rounded-full shadow-xl hover:bg-[#c53030] transition-colors"
    >
      <Phone className="h-5 w-5" /> <span className="hidden sm:inline">Emergency</span>
    </a>
  </div>
);
